var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{attrs:{"type":_vm.type,"variant":_vm.variant,"size":_vm.size,"disabled":_vm.saving || _vm.disabled}},[(_vm.saving)?_c('font-awesome-icon',{attrs:{"icon":['fas', 'spinner'],"spin":""}}):_vm._e(),_vm._v(" "+_vm._s(_vm.text)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }